import { __rest } from "tslib";
import * as React from 'react';
export var LevelItem = function LevelItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["children"]);

  return React.createElement("div", Object.assign({}, props), children);
};